<script>
export const group = 'Full'
</script>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
const gsapTimeline = useGsapTimeline()

const emit = defineEmits(['loaded'])

const props = defineProps({
  item: Object,
  fade: { type: Boolean, default: true },
})

const imageLayerA = computed(() => props.item.enrichment.item.layers[0])
const imageLayerB = computed(() => props.item.enrichment.item.layers[1])

const imageAElement = ref(null)
const imageBElement = ref(null)

const imageALoaded = ref(false)
const imageBLoaded = ref(false)

const allImagesLoaded = computed(() => imageALoaded.value && imageBLoaded.value)

onMounted(() => {
  const handleImageLoad = (imgRef, loadedRef) => {
    if (imgRef.value) {
      if (imgRef.value.complete) {
        loadedRef.value = true
      } else {
        imgRef.value.addEventListener(
          'load',
          () => {
            loadedRef.value = true
          },
          { once: true }
        )
      }
    } else {
      loadedRef.value = true
    }
  }

  watch(
    imageAElement,
    () => {
      handleImageLoad(imageAElement, imageALoaded)
    },
    { immediate: true }
  )

  watch(
    imageBElement,
    () => {
      handleImageLoad(imageBElement, imageBLoaded)
    },
    { immediate: true }
  )

  const animatedLayers = [imageLayerA.value?.should_move ? imageAElement : null, imageLayerB.value?.should_move ? imageBElement : null].filter(Boolean)

  gsapTimeline().to(animatedLayers, {
    scale: 1.05,
    transformOrigin: 'top left',
    ease: 'linear',
    duration: 15,
  })
})

watch(allImagesLoaded, (loaded) => {
  if (loaded) emit('loaded')
})
</script>

<template>
  <div class="absolute w-full h-full">
    <img
      v-if="imageLayerA"
      ref="imageAElement"
      :key="imageLayerA.image"
      :src="imageLayerA.image"
      class="w-full h-full object-cover absolute"
      :class="{ 'transition-opacity duration-700': fade }"
      :style="{ opacity: !fade || allImagesLoaded ? 1 : 0 }"
    />
    <img
      v-if="imageLayerB"
      ref="imageBElement"
      :key="imageLayerB.image"
      :src="imageLayerB.image"
      class="w-full h-full object-cover absolute"
      :class="{ 'transition-opacity duration-700': fade }"
      :style="{ opacity: !fade || allImagesLoaded ? 1 : 0 }"
    />
  </div>
</template>
